import { FileText } from 'lucide-react'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { Spinner } from '@/components/ui/spinner'

type Props = {
  open: boolean
  onOpenChange: (open: boolean) => void
  F1: string
  F2: string
  F3: string
  data: string
  submitting: boolean
  onConfirm: () => void
}

export function AutoletturaConfirmDialog({
  open,
  onOpenChange,
  F1,
  F2,
  F3,
  data,
  submitting,
  onConfirm,
}: Props) {
  return (
    <Dialog open={open} onOpenChange={(o) => !submitting && onOpenChange(o)}>
      <DialogContent>
        <DialogHeader>
          <div className="mb-2 flex h-10 w-10 items-center justify-center rounded-full bg-secondary/15 text-secondary">
            <FileText className="h-5 w-5" />
          </div>
          <DialogTitle>Conferma autolettura</DialogTitle>
          <DialogDescription>Controlla i dati prima di inviare.</DialogDescription>
        </DialogHeader>

        <ul className="mt-4 rounded-lg bg-muted/40 px-4 py-2">
          <Row label="Fascia F1 (A1+)" value={`${F1} kWh`} />
          <Row label="Fascia F2 (A2+)" value={`${F2} kWh`} />
          <Row label="Fascia F3 (A3+)" value={`${F3} kWh`} />
          <Row label="Data rilevazione" value={data} isLast />
        </ul>

        <DialogFooter>
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            disabled={submitting}
          >
            Annulla
          </Button>
          <Button onClick={onConfirm} disabled={submitting}>
            {submitting ? <Spinner className="text-secondary-foreground" /> : 'Conferma'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

function Row({ label, value, isLast }: { label: string; value: string; isLast?: boolean }) {
  return (
    <li
      className={`flex items-center justify-between py-3 ${isLast ? '' : 'border-b border-border'}`}
    >
      <span className="text-sm text-muted-foreground">{label}</span>
      <span className="text-sm font-semibold tabular-nums text-foreground">{value}</span>
    </li>
  )
}
